import { Injectable } from '@angular/core';
import * as Rx from 'rxjs';
import { Defaults } from '../../defaults';
import { TokenService } from '../auth/token/token.service';
import { webSocket, WebSocketSubject, WebSocketSubjectConfig } from 'rxjs/webSocket';
import { castArray } from 'lodash';

@Injectable()
export class WebsocketService {
  constructor(
    private defaults: Defaults,
    private tokenService: TokenService
  ) {}

  init(url, websocketConfig: WebSocketConfig = new WebSocketConfig()): Promise<CustomWS> {
    let openObserver = new Rx.Subject();
    let ws: WebSocketSubject<any>;

    return new Promise((resolve, reject) => {
      this.tokenService.checkAndGetNewToken().subscribe(() => {
        const onOpen = Promise.resolve();
        const protocol = websocketConfig.protocol ? castArray(websocketConfig.protocol) : [];

        if (this.tokenService.token) {
          protocol.push('json', `Bearer${this.tokenService.token}`);
        }

        let config: WebSocketSubjectConfig<any> = {
          url: (websocketConfig.root || this.defaults.socket) + url,
          protocol,
          openObserver: openObserver,

          deserializer: ({ data }) => {
            try {
              return JSON.parse(data);
            } catch (e) {
              return data;
            }
          }
        };
        ws = webSocket(config);

        resolve({ webSocket: ws, onOpen: onOpen });
      });
    });
  }
}

export interface CustomWS {
  onOpen: Promise<any>;
  webSocket: WebSocketSubject<any>;
}

class WebSocketConfig {
  sendToken?: boolean = true;
  root?: string;
  protocol?: string;
}
